<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="summary"/>
       <MenuTeamReportAndSummaryList/>
       <EmployeeSummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import EmployeeSummaryList from '@/components/menuadmin/team/teamreportandsummary/EmployeeSummaryList.vue'
export default {
    name:'employeeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        EmployeeSummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>